import { Pipe, PipeTransform } from '@angular/core';

import moment_ from 'moment';
const moment = moment_;

@Pipe({
    name: 'timeAfter'
})
export class TimeAfterPipe implements PipeTransform {
    // times obj must contain a value in a 'HH:mm' format
    transform(times: any[], initialTime: string | undefined, intervalMins?: number): any {
        if (!initialTime) {
            return times;
        }

        let initialTimeMoment = moment(initialTime, 'HH:mm');
        if (intervalMins) {
            initialTimeMoment.add(intervalMins - 1, 'minutes');
        }

        let result = times.filter((time) => {
            let t = moment(time.value, 'HH:mm');
            return t.isSameOrAfter(initialTimeMoment);
        });

        return result;
    }
}
